<!--  Grupos -->
@if (grupos().length > 0) {
<div class="py-2 px-4 flex items-center gap-2 bg-slate-100">
  <span class="subheading-1">Agrupado por: </span>
  <div
    class="flex flex-row gap-2 flex-nowrap"
    cdkDropList
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="dropGrupo($event)"
  >
    @for (grupo of grupos(); track index; let index = $index) {
    <div
      class="flex flex-row items-center bg-primary-200 rounded-xl text-primary-800 h-7 pl-3 gap-4"
      cdkDrag
      [cdkDragData]="grupo"
    >
      <span matTooltip="Arraste para reordenar">
        {{ grupo.descricao }}
      </span>
      <div class="flex flex-row items-center mr-2">
        <mat-icon
          matTooltip="Expandir todos"
          class="icon-sm cursor-pointer slc-color-brand"
          svgIcon="mat:keyboard_double_arrow_down"
          (click)="grupoExpandirRetrairTudo(grupo, true)"
        ></mat-icon>
        <mat-icon
          matTooltip="Retrair todos"
          class="icon-sm cursor-pointer slc-color-brand"
          svgIcon="mat:keyboard_double_arrow_up"
          (click)="grupoExpandirRetrairTudo(grupo, false)"
        ></mat-icon>
        <mat-icon
          matTooltip="Remover"
          class="icon-sm cursor-pointer slc-color-brand"
          svgIcon="mat:cancel"
          (click)="grupoRemover(grupo)"
        ></mat-icon>
      </div>
    </div>
    }
  </div>
</div>
}
